/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FaxDocumentSenderSourceContactsInner } from './FaxDocumentSenderSourceContactsInner';
import {
    FaxDocumentSenderSourceContactsInnerFromJSON,
    FaxDocumentSenderSourceContactsInnerFromJSONTyped,
    FaxDocumentSenderSourceContactsInnerToJSON,
} from './FaxDocumentSenderSourceContactsInner';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
} from './FindAllSourceTags200ResponseDataInner';

/**
 * Source information for the sender of the fax
 * @export
 * @interface FaxDocumentSenderSource
 */
export interface FaxDocumentSenderSource {
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    location?: string | null;
    /**
     * 
     * @type {Array<FaxDocumentSenderSourceContactsInner>}
     * @memberof FaxDocumentSenderSource
     */
    contacts?: Array<FaxDocumentSenderSourceContactsInner>;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    npi_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    tag_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaxDocumentSenderSource
     */
    type?: string | null;
    /**
     * 
     * @type {FindAllSourceTags200ResponseDataInner}
     * @memberof FaxDocumentSenderSource
     */
    tag?: FindAllSourceTags200ResponseDataInner;
}

/**
 * Check if a given object implements the FaxDocumentSenderSource interface.
 */
export function instanceOfFaxDocumentSenderSource(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FaxDocumentSenderSourceFromJSON(json: any): FaxDocumentSenderSource {
    return FaxDocumentSenderSourceFromJSONTyped(json, false);
}

export function FaxDocumentSenderSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocumentSenderSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'contacts': !exists(json, 'contacts') ? undefined : ((json['contacts'] as Array<any>).map(FaxDocumentSenderSourceContactsInnerFromJSON)),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'npi_number': !exists(json, 'npi_number') ? undefined : json['npi_number'],
        'tag_id': !exists(json, 'tag_id') ? undefined : json['tag_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'tag': !exists(json, 'tag') ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['tag']),
    };
}

export function FaxDocumentSenderSourceToJSON(value?: FaxDocumentSenderSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'location': value.location,
        'contacts': value.contacts === undefined ? undefined : ((value.contacts as Array<any>).map(FaxDocumentSenderSourceContactsInnerToJSON)),
        'phone': value.phone,
        'email': value.email,
        'npi_number': value.npi_number,
        'tag_id': value.tag_id,
        'type': value.type,
        'tag': FindAllSourceTags200ResponseDataInnerToJSON(value.tag),
    };
}

